export const REPORT_ID = "slide-35";
export const SLIDE_NUMBER = 35;
